import { Translations } from './translations'

export const en: Translations = {
  // Header
  title: 'GPT Clicker',
  subtitle: 'AI Training Tycoon',
  settings: 'Settings',

  // Resources
  resources: 'Resources',
  money: 'Money',
  energy: 'Energy',
  compute: 'Compute',
  quality: 'Quality',
  totalUsers: 'Total Users',
  price: 'Price',
  research: 'Research',

  // Actions
  train: 'Train',
  trainCost: 'Cost',
  qualityGain: 'quality',
  inference: 'Inference',
  needUsers: 'Need users!',
  usersWaiting: 'users waiting',
  qualityToAttract: 'Quality > 40% to attract',
  researchAction: 'Research',
  unlocksAfter: 'Unlocks after',
  computeSpent: 'compute spent',
  cost: 'Cost',

  // Hardware
  hardware: 'Hardware',
  computePerSec: 'compute/s',
  usesEnergy: 'uses',
  devicesTotal: 'devices total',

  // Models
  training: 'Training',
  yourModels: 'Your Models',
  params: 'params',
  maxUsers: 'Max users',
  trainCost2: 'Train cost',
  unlocked: 'unlocked',
  researchPoints: 'research',

  // Upgrades
  upgrades: 'Upgrades',
  upgradesLockedMsg: 'Train your model to 50% quality to unlock upgrades',
  max: 'MAX',

  // Footer
  computeSpentStat: 'Compute Spent',
  time: 'Time',
  resetGame: 'Reset Game',
  resetConfirm: 'Are you sure you want to reset all progress?',
  pause: 'Pause',
  resume: 'Resume',

  // Event Log
  eventLog: 'Event Log',
  welcome: 'Welcome to GPT Clicker! Train your model to begin.',

  // Price
  market: 'Market',
  pricePerMillion: '$/1M tokens',

  // Tags
  tagEnergy: 'ENRGY',
  tagCompute: 'COMP',
  tagHw: 'HW',
  tagTrain: 'TRAIN',
  tagResearch: 'RSRCH',
  tagAuto: 'AUTO',

  // Tutorial messages
  tutorialWelcome: 'Year 2020. You have an idea: train a small language model based on the transformer architecture.',
  tutorialFirstTrain: 'Training started! Your laptop converts energy into compute. Each training run improves model quality.',
  tutorialQuality20: 'Model is learning basic patterns. Keep training to improve quality.',
  tutorialQuality40: 'Quality above 40%! Your model can now generate somewhat coherent text. Users are starting to notice...',
  tutorialQuality50: 'Upgrades unlocked! Use your earnings to buy better hardware and expand your energy capacity.',
  tutorialFirstUsers: 'Your first users! Click INFERENCE to serve their requests and earn money.',
  tutorialUsers10: 'Word is spreading. More users are trying your model. Consider raising the price...',
  tutorialMoney100: 'You have $100! Time to upgrade your hardware. Better GPUs = more compute = faster training.',
  tutorialMoney1k: 'Your little AI project is becoming a real business. Investors are starting to call...',
  tutorialResearchUnlock: 'RESEARCH unlocked! Spend compute on research to unlock bigger, more powerful models.',
  tutorialFirstResearch: 'Research points accumulate. When you have enough, you can unlock the next model architecture.',
  tutorialGpt2Small: 'GPT-2 Small unlocked! This architecture can handle more complex tasks. Train it from scratch.',
  tutorialGpt2Large: 'GPT-2 Large! People are saying this might be "too dangerous to release"...',
  tutorialGpt3: 'GPT-3 era begins. Few-shot learning changes everything. The world is watching.',
  tutorialGpt4: 'GPT-4 is here. Multimodal, reasoning, and scarily capable. The AI race intensifies.',
  tutorialAgi: 'You did it. AGI is here. It understands. It improves itself. What happens next is up to you...',
  tutorialHwGaming: 'Nice GPU! Training is much faster now. Your neighbors might complain about the electricity bill.',
  tutorialHwServer: "A real server rack! You've moved beyond the garage. Time to rent some office space.",
  tutorialHwDatacenter: "Your own datacenter! You're now competing with the big tech companies.",
  tutorialHwSatellite: 'Orbital compute! The Moonlink constellation provides unprecedented processing power from space.',
  tutorialHwQuantum: 'Quantum supremacy achieved. The QC-1024 operates on principles that would make Einstein nervous.',
  tutorialUsers100: "100 users! You're gaining traction. Tech blogs are writing about you.",
  tutorialUsers1k: '1,000 users! You need to hire a support team. And maybe some lawyers.',
  tutorialUsers100k: "100K users! You're a unicorn startup now. VCs are fighting to give you money.",
  tutorialUsers1m: "ONE MILLION USERS! You're reshaping how humanity interacts with technology.",

  // Model descriptions
  modelTinyDesc: 'A humble beginning. Barely coherent, but it works.',
  modelGpt2SmallDesc: 'The model that started it all. Actually useful.',
  modelGpt2LargeDesc: 'Too dangerous to release... or is it?',
  modelGpt3Desc: 'Few-shot learning. The world takes notice.',
  modelGpt4Desc: 'Multimodal. Reasoning. The arms race begins.',
  modelAgiDesc: 'It understands. It improves itself. What now?',

  // Upgrade names and descriptions
  upgradeLaptopOverclock: 'Overclock Laptop',
  upgradeLaptopOverclockDesc: 'Push your laptop harder: +2 compute/sec',
  upgradeBetterOutlet: 'Better Power Outlet',
  upgradeBetterOutletDesc: '+50 max energy',
  upgradeSolarPanel: 'Solar Panel',
  upgradeSolarPanelDesc: '+1 energy/sec regen',
  upgradePowerGrid: 'Power Grid Connection',
  upgradePowerGridDesc: '+5 energy/sec regen',
  upgradeNuclearPlant: 'Nuclear Plant',
  upgradeNuclearPlantDesc: '+20 energy/sec regen',
  upgradeFusionReactor: 'Fusion Reactor',
  upgradeFusionReactorDesc: '+100 energy/sec regen',
  upgradeDysonSphere: 'Dyson Sphere',
  upgradeDysonSphereDesc: '+1000 energy/sec regen',
  upgradeRamUpgrade: 'RAM Upgrade',
  upgradeRamUpgradeDesc: '+50 max compute',
  upgradeSsdArray: 'SSD Array',
  upgradeSsdArrayDesc: '+200 max compute',
  upgradeBetterOptimizer: 'Better Optimizer',
  upgradeBetterOptimizerDesc: '+20% training efficiency',
  upgradeResearchPapers: 'Research Papers',
  upgradeResearchPapersDesc: '+20% research efficiency',
  upgradeSelfServicePortal: 'Self-Service Portal',
  upgradeSelfServicePortalDesc: 'Users serve themselves: 0.5 auto-inferences/sec',
  upgradeApiAccess: 'API Access',
  upgradeApiAccessDesc: 'Developers integrate your model: +1 auto-inference/sec',
  upgradeMobileApp: 'Mobile App',
  upgradeMobileAppDesc: 'Users on the go: +2 auto-inferences/sec',
  upgradeEnterpriseTier: 'Enterprise Tier',
  upgradeEnterpriseTierDesc: 'Big clients, big volume: +5 auto-inferences/sec',
  upgradeGlobalCdn: 'Global CDN',
  upgradeGlobalCdnDesc: 'Worldwide low-latency: +10 auto-inferences/sec',
  upgradeBasicChatbot: 'Basic Chatbot',
  upgradeBasicChatbotDesc: 'A simple web widget: +0.2 auto-inferences/sec',

  // Hardware upgrade descriptions
  hwUsedGpuDesc: 'Used GPU: +3 compute/sec',
  hwGamingGpuDesc: 'Gaming GPU: +8 compute/sec',
  hwProGpuDesc: 'Pro GPU: +20 compute/sec',
  hwWorkstationDesc: 'Workstation: +50 compute/sec',
  hwServerRackDesc: 'Server rack (4x A100): +120 compute/sec',
  hwGpuClusterDesc: 'GPU cluster (8x H100): +300 compute/sec',
  hwMiniDatacenterDesc: 'Edge datacenter: +800 compute/sec',
  hwDatacenterDesc: 'Datacenter: +2K compute/sec',
  hwMegaDatacenterDesc: 'Mega datacenter: +5K compute/sec',
  hwDatacenterNetworkDesc: 'Global network: +15K compute/sec',
  hwSupercomputerDesc: 'Supercomputer: +50K compute/sec',
  hwSatelliteDesc: 'Orbital satellites: +200K compute/sec',
  hwQuantumDesc: 'Quantum computer: +1M compute/sec',

  // Misc
  purchased: 'Purchased',
  switchedTo: 'Switched to training',
  unlockedModel: 'Unlocked',
  scalesToUsers: 'Scales to',
  trainItToAttract: 'users. Train it to attract users!',
  unlimited: 'unlimited',
  language: 'Language',
  
  // Mobile labels
  mobileResources: 'Resources',
  mobileModels: 'Models',
  mobileHardware: 'Hardware',
  mobileUpgrades: 'Upgrades',
  sell: 'Sell',
  sellFor: 'Sell for',
  discontinueConfirm: 'Discontinue {model}? Users will migrate to other models.',
  autoInference: 'Auto-inference',
  autoInferenceRate: 'Auto Infer',
  autoTrain: 'Auto-train',
  autoTrainRate: 'Auto Train',
  autoResearch: 'Auto-research',
  autoResearchRate: 'Auto Research',

  // Tooltips
  tooltipTitle: 'GPT Clicker - Train AI models, serve users, build your AI empire!',
  tooltipMoney: 'Money - Earned from user inferences. Use to buy upgrades and hardware.',
  tooltipEnergy: 'Energy - Regenerates over time. Powers your hardware to generate compute.',
  tooltipCompute: 'Compute - Generated by hardware. Used for training, inference, and research.',
  tooltipResearch: 'Research Points - Spend compute to earn RP. Use RP to unlock new AI models.',
  tooltipUsers: 'Users - Attracted by model quality. More users = more revenue per inference.',
  tooltipComputeSpent: 'Total Compute Spent - Lifetime compute used for training and research.',
  tooltipPlayTime: 'Play Time - How long you\'ve been building your AI empire.',
  tooltipSettings: 'Settings - Debug options, reset game',

  // Share
  shareButton: 'Share',
  shareText: "I'm building an AI empire in GPT Clicker! {users} users, {money} revenue, training {model}. Can you beat my {time} run?",
  shareCopied: 'Text copied!',
  imageCopied: 'Image copied!',
  shareChallenge: 'Can you beat me?',
  shareTitle: 'Share your progress',
  shareDownload: 'Save Image',
  model: 'Model',

  // Feedback
  feedback: 'Feedback',
  feedbackTitle: 'Send Feedback',
  feedbackPlaceholder: 'Tell us what you think about GPT Clicker...',
  feedbackEmailPlaceholder: 'Email (optional)',
  feedbackSend: 'Send',
  feedbackSending: 'Sending...',
  feedbackSuccess: 'Thanks for your feedback!',
  feedbackError: 'Error sending feedback. Please try again.',
  feedbackRateLimit: 'Too many requests. Please wait before sending more feedback.',
  feedbackClose: 'Close',

  // Console messages
  consoleGameLoaded: 'Game loaded from save',
  consoleGameSaved: 'Game saved',
  consoleFailedToSave: 'Failed to save game:',
  consoleFailedToLoad: 'Failed to load game:',
  consoleFailedToClear: 'Failed to clear save:',

  // Victory
  victoryTitle: 'Congratulations!',
  victorySubtitle: 'Human Civilization has reached the Singularity',
  victoryTime: 'Time to Singularity',
  victoryCta: 'Should we build Singularity Clicker? Leave a comment on social media!',
  victoryClose: 'Continue Playing',
}
